goog.provide("shadow.js.shim.module$$mui$material$Stack$default");
shadow.js.shim.module$$mui$material$Stack$default = shadow.js.shim.module$$mui$material$Stack.default;
